import React from 'react';
import { Page } from 'components/layout';
import { Box } from 'components/ui';
import StakeList from 'components/Staking/StakeList';
import { ThemeProvider } from 'styled-components';
import { theme } from 'utils/styles';
import merge from 'lodash/merge';
import ConnectedWalletGuard from 'components/ConnectedWalletGuard';
import { ebChainId } from 'utils/config';

const stakeTheme = merge({}, theme, {
  colors: {
    ...theme.colors,
    highlight: theme.colors.oranges.light,
  },
});

const StakePage: React.FC<{}> = () => {
  return (
    <ThemeProvider theme={stakeTheme}>
      <Page title="Stake" p={[0, 0, '1']} fixedFooter={false}>
        <Box p={[0, 0, null]} maxWidth="1000px" margin="0 auto">
          <ConnectedWalletGuard networkId={ebChainId}>
            <StakeList />
          </ConnectedWalletGuard>
        </Box>
      </Page>
    </ThemeProvider>
  );
};

export default StakePage;
